import {bootstrapModule} from 'src/utilities/vuex'
import {parseDriver, cleanRssDescription} from 'src/utilities/utils'
import Constants from 'src/utilities/constants'
import Vue from 'vue'
import Parser from 'rss-parser'

let initialState = {
  devices: []
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const _inTouchGpsStore = {
  namespaced: true,
  state,
  actions: {
    async fetchGpsDevices ({ commit }) {
      try {
        const parser = new Parser({
          customFields: {
            item: ['description', 'imei', 'vin', 'georss:point', 'speed']
          }
        })
        let feed = await parser.parseURL('https://eileenmerrittinc.intouchgps.com/readings/public/42931')
        const items = []
        feed.items.forEach((device) => {
          if (device.hasOwnProperty('title')) {
            device.title = parseDriver(device.title)
            device.description = cleanRssDescription(device.description)
            items.push(device)
          }
        })
        commit('devices', items)
        return {
          result: Constants.RETURN_CODES.SUCCESS
        }
      } catch (err) {
        return {
          result: Constants.RETURN_CODES.ERROR,
          errors: JSON.stringify(err)
        }
      }
    }
  },
  mutations: {
    reset (state) {
      for (let f in state) {
        Vue.set(state, f, initialState[f])
      }
    }
  }
}

export {_inTouchGpsStore}

export default bootstrapModule(_inTouchGpsStore)
